import SliderImage from "./Slider/SliderImage";


function IntroductionBoostan() {
    return (
        <div className="flex items-center justify-between 
                        2xl:px-60
                        xl:px-40
                        lg:px-10 lg:pt-20
                        md:px-10 md:pt-10 md:flex-row
                        flex-col
                        ">
            <img src="/image/BoostanLogo.png" alt="logo"
                className="2xl:w-6/12 
                            xl:w-7/12
                            lg:w-8/12
                            md:w-5/12
                            sm:w-8/12
                            w-10/12
                            " />
            {/* <SliderImage /> */}
            <div className="text-right ml-10
                            md:w-7/12 
                            w-10/12 rtol
                            ">
                <h1 className="t-purpleDark  fontTitr
                                lg:text-4xl lg:mb-10
                                md:text-2xl md:mb-5 md:fontTitr
                                text-xl mb-2
                                ">پیام رسان بوستان</h1>
                <p className="t-purpleDark 
                               2xl:text-lg
                               lg:mb-4 lg:text-base
                               md:mb-5
                               text-sm mb-2
                                 ">با پیام‌رسان بوستان، ارتباط با دوستانتان آسان‌تر از همیشه است.</p>
                {/* <div className="flex flex-row-reverse text-right 
                                lg:mb-8
                                md:mb-5
                                mb-2
                                ">
                    <p className="text-slate-700 font-bold">لورم ایپسوم</p>
                    <p className="t-gray mr-10">لورم ایپسوم</p>
                </div> */}
                <p className="text-gray-500 
                                 md:text-base md:leading-9
                                 text-sm leading-8
                                 ">پیام‌رسان بوستان نه تنها امکان چت شخصی و گروهی را فراهم می‌کند، بلکه مجموعه‌ای از ویژگی‌های منحصر به فرد را برای تجربه‌ای کامل و سرگرم‌کننده ارائه می‌دهد.</p>
                <p className="text-gray-500 
                                 md:text-base md:leading-9
                                 text-sm leading-8 font-bold
                                 ">ویژگی‌های برجسته پیام‌رسان بوستان:</p>
                <p className="text-gray-500 
                                 md:text-base md:leading-9
                                 text-sm leading-8
                                 ">چت صوتی امن و با کیفیت -

                    ایجاد کانال و گروه‌های اختصاصی -

                    انتخاب و دنبال کردن کانال‌های منتخب -

                    تماس صوتی سریع و مطمئن -

                    نمایش نوتیفیکیشن‌ها و اعلان‌های مهم -

                    انجام تراکنش‌های مالی در محیط امن -

                    تماشای فیلم، سریال و پادکست -

                    دسترسی به رویدادهای روزانه و شخصی -

                    فیلترینگ هوشمند برای تجربه شخصی‌سازی شده -

                    بازی‌های آنلاین سرگرم‌کننده -

                    داشتن ویترین و فروشگاه اینترنتی -

                    تماشای ویدیو به‌صورت آنلاین - با بوستان، همه چیز در یک محیط امن، سریع و جذاب در دسترس شماست. </p>
            </div>
        </div>
    )
}
export default IntroductionBoostan;